import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, VStack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import FormSelect from "../../form/FormSelect";
import FormControl from "../../form/FormControl";
const ProtocolSection = ({ protocols }) => {
    const { t } = useTranslation();
    return (_jsxs(VStack, Object.assign({ space: 6 }, { children: [_jsx(FormSelect, { choices: protocols.map((instruction) => ({
                    value: instruction,
                    label: instruction,
                })), name: "instructions", label: t("measures:protocol"), labelProps: { _text: { color: "gray.800" } } }), _jsx(Box, { children: _jsx(FormControl, { label: t("measures:protocolDescription"), name: "instructions", multiline: true, numberOfLines: 4, labelProps: {
                        _text: { color: "gray.800" },
                    } }) })] })));
};
export default ProtocolSection;
